import { AgGridService } from "@topline/services/agGridService";
import { MarketDataProvider } from "../../Market/services/marketDataProvider";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('imsBrandSearch', {
        template: require('./imsBrandSearchComponent.html'),
        bindings: {
            onBrandAdding: '&',
            onSkuAdding: '&',
            onBrandsAdding: '&',
            skuIdToRemove: '<',
            refreshCallback: '=',
            config: '<'
        },
        controller: ['$scope', MarketDataProvider.componentName, AgGridService.componentName, angularServicesNames.$translate, function(
            this: $TSFixMe,
            $scope: $TSFixMe,
            marketDataProvider: MarketDataProvider,
            agGridService: AgGridService,
            $translate: ng.translate.ITranslateService
        ) {
            var $ctrl = this;
            var skipSkusId: $TSFixMe = [];
            
            $scope.$on('LanguageChanged', () => agGridService.refreshGridLanguage($ctrl.gridApi));

            $ctrl.gridOptions = {
                columnDefs: [
                    {
                        headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.BRAND"), field: "brand", cellRenderer: 'agGroupCellRenderer'
                    },
                    {
                        headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.MARKET"), field: "market"
                    },
                    {
                        headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.MOLECULES"), field: "molecules",
                        cellRenderer: () => '<div class="ui-grid-cell-contents" title="{{ data.molecules | join: \',\' }}"><span ng-repeat-start="m in data.molecules">{{m}}<span ng-if="!$last">, </span></span><span ng-repeat-end=""></span></div>'

                    },
                    {
                        headerValueGetter: () => $translate.instant("ACTIONS"),
                        cellRenderer: () => '<div class="ui-grid-cell-contents"><a href="#" ng-click="$ctrl.addBrand(data)"><i class="glyphicon glyphicon-plus"></i></a></div>',
                        filter: true,
                        sortable: true,
                        suppressMenu: true
                    }
                ],
                angularCompileRows: true,
                animateRows: true,
                masterDetail: true,
                defaultColDef: {
                    sortable: true,
                    resizable: true
                },
                detailCellRendererParams: {
                    detailGridOptions: {
                        columnDefs: [
                            { field: 'sku' },
                            { field: 'pharmacyMarket', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.PHARMACY_MARKET") },
                            { field: 'atcOtc3', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.ATCOTC3") },
                            { field: 'atcOtc4', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.ATCOTC4") },
                            { field: 'nfc3', headerValueGetter: () => $translate.instant("MARKET.SELECTED_SKU_GRID.NFC3") },
                            {
                                field: 'actions', headerValueGetter: () => $translate.instant("ACTIONS"),
                                cellRenderer: (x: $TSFixMe, y: $TSFixMe, z: $TSFixMe) => {
                                    return '<div class="ui-grid-cell-contents"><a href="#" ng-click="$ctrl.addSku(data.parentBrand, data)"><i class="glyphicon glyphicon-plus"></i></a></div>';
                                }
                            },

                        ],
                        domLayout: 'autoHeight',
                        angularCompileRows: true,
                        localeTextFunc: agGridService.transalteFunc,
                        onFirstDataRendered(params: $TSFixMe) {
                            // fit the detail grid columns
                            params.api.sizeColumnsToFit();
                        }
                    },
                    getDetailRowData: function (params: $TSFixMe) {
                        for (const sku of params.data.skus) {
                            sku.parentBrand = params.data;
                        }
                        params.successCallback(params.data.skus);
                    }
                },
                getRowHeight: function (params: $TSFixMe) {
                    if (params.node && params.node.detail) {
                        const offset = 80;
                        const allDetailRowHeight = params.data.skus.length * 28;
                        return allDetailRowHeight + offset;
                    } else {
                        // otherwise return fixed master row height
                        return 30;
                    }
                },
                pagination: true,
                paginationPageSize: 10,
                rowModelType: 'serverSide',
                rowGroupPanelShow: 'never',
                suppressMultiSort: true,
                domLayout: 'autoHeight',
                localeTextFunc: agGridService.transalteFunc,
                suppressHorizontalScroll: true,
                onGridReady: (config: $TSFixMe) => {
                    $ctrl.gridApi = config.api;
                    config.api.setServerSideDatasource(marketDataProvider.createBrandsDataSource($ctrl.filterConfig));
                    config.api.sizeColumnsToFit();
                },
                onGridSizeChanged: (config: $TSFixMe) => {
                    config.api.sizeColumnsToFit();
                }
            }

            function updateGridDisplayData() {
                $ctrl.filterConfig.skipSkusIds = skipSkusId;
                $ctrl.reloadBrands();
            }

            $ctrl.brandNameFilterChange = function () {
                if ($ctrl.filterConfig.brandName.length > 2 || $ctrl.filterConfig.brandName.length == 0) {
                    $ctrl.reloadBrands();
                }
            };

            $ctrl.availableMolecues = [];
            $ctrl.findMolecule = function (searchString: $TSFixMe) {
                marketDataProvider.findMolecule(searchString).then(function (data: $TSFixMe) {
                    $ctrl.availableMolecules = data;
                });
            };

            $ctrl.availableAtc3 = [];
            $ctrl.findAtc3 = function (searchString: $TSFixMe) {
                marketDataProvider.findAtc3(searchString).then(function (data: $TSFixMe) {
                    $ctrl.availableAtc3 = data;
                });
            };

            $ctrl.availableAtc4 = [];
            $scope.$watch('$ctrl.filterConfig.atc3', function (newValue: $TSFixMe) {
                if (newValue) {
                    marketDataProvider.loadAtc4($ctrl.filterConfig.atc3).then(function (data: $TSFixMe) {
                        $ctrl.availableAtc4 = data;
                    });
                } else {
                    $ctrl.availableAtc4 = [];
                    $ctrl.filterConfig.atc4 = null;
                }
            });

            $ctrl.findNfc3 = function (searchString: $TSFixMe) {
                $ctrl.availableNfc3 = [];
                const molecules = $ctrl.filterConfig.molecules.map((x: $TSFixMe) => x.name);
                
                let debounce = _.debounce((searchString: $TSFixMe, molecules: $TSFixMe) => marketDataProvider.findNfc3(searchString, molecules).then(function (data: $TSFixMe) {
                    $ctrl.availableNfc3 = data;
                }), 500);
                debounce(searchString, molecules);
            };

            $ctrl.pharmacyMarkets = [];
            marketDataProvider.loadPharmacyMarkets().then(function (data: $TSFixMe) {
                $ctrl.pharmacyMarkets = data;
            });

            $ctrl.perscirptionMarkets = [];
            marketDataProvider.loadPerscirptionMarket().then(function (data: $TSFixMe) {
                $ctrl.perscirptionMarkets = data;
            });

            $ctrl.moleculeTypes = [];
            marketDataProvider.loadMoleculeType().then(function (data: $TSFixMe) {
                $ctrl.moleculeTypes = data;
            });

            function filterConfigSetup() {
                $ctrl.filterConfig = {
                    pharmacyMarket: getValueFromConfig('pharmacyMarket.filter', null),
                    perscirptionMarket: getValueFromConfig('perscirptionMarket.filter', null),
                    atc3: getValueFromConfig('atc3.filter', null),
                    atc4: getValueFromConfig('act4.filter', null),
                    nfc3: getValueFromConfig('nfc3.filter', null),
                    skipSkusIds: [],
                    molecules: getValueFromConfig('molecules.filter', []),
                    brandName: null,
                    moleculeType: null,
                };
            }

            const getValueFromConfig = (key: $TSFixMe, defaultValue: $TSFixMe) => {

                return angular._get($ctrl.config, key, defaultValue);
            };

            $ctrl.reloadBrands = function () {
                if ($ctrl.gridApi) {
                    $ctrl.gridApi.onFilterChanged();
                }
            };

            $ctrl.$onInit = () => {
                $ctrl.refreshCallback = () => {
                    skipSkusId = [];
                    filterConfigSetup();
                    $ctrl.reloadBrands();
                };

                filterConfigSetup();
                $ctrl.loadingBrands = false;
                $ctrl.page = 1;
            };

            $scope.$watchCollection('$ctrl.skuIdToRemove', function (newVal: $TSFixMe) {
                if (newVal) {
                    if (newVal.length > 0) {
                        for (let productIndex of newVal) {
                            var indexToRemove = skipSkusId.indexOf(productIndex);
                            if (indexToRemove > -1) {
                                skipSkusId.splice(indexToRemove, 1);
                            }
                        }
                        updateGridDisplayData();
                    } else {
                        skipSkusId = [];
                        filterConfigSetup();
                        updateGridDisplayData();
                    }
                }
            });

            $ctrl.addSku = (b: $TSFixMe, s: $TSFixMe) => {
                skipSkusId.push(s.id)
                $ctrl.onSkuAdding({ brand: b, sku: s });
                updateGridDisplayData();
            }

            $ctrl.addBrand = function (b: $TSFixMe) {
                $ctrl.onBrandAdding({ brand: b });
                for (var i = 0, max = b.skus.length; i < max; i++) {
                    skipSkusId.push(b.skus[i].id)
                }
                updateGridDisplayData();
            };

            $ctrl.addAll = function () {
                if ($ctrl.totalItems > 5000) {
                    alert($translate.instant('MARKET.TWO_MANY_TO_ADD'));
                    return;
                }

                var filterConfig = angular.copy($ctrl.filterConfig);
                filterConfig.pageSize = 2147483647;
                filterConfig.page = 1;
                marketDataProvider.getBrands(filterConfig).then(function (data: $TSFixMe) {
                    $ctrl.onBrandsAdding({ brands: data.items });
                    for (var i = 0, max = data.items.length; i < max; i++) {
                        for (var j = 0, maximum = data.items[i].skus.length; j < maximum; j++) {
                            skipSkusId.push(data.items[i].skus[j].id);
                        }
                    }
                    updateGridDisplayData();
                });
            };
        }]
    });

})(angular.module('topline.modules'));